var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeactivatedIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.600098 0H13.6001L20.6001 4V20H7.6001L0.600098 16V0Z",
  fill: "#E0A3A3"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6002 10.7072L13.7466 13.8536L14.4537 13.1465L11.3073 10.0001L14.4537 6.85364L13.7466 6.14653L10.6002 9.29295L7.45369 6.14648L6.74658 6.85359L9.89305 10.0001L6.74658 13.1465L7.45369 13.8536L10.6002 10.7072Z",
  fill: "#861313"
})));
export { SvgDeactivatedIcon as ReactComponent };
export default __webpack_public_path__ + "assets/f5411abf.svg";